const custosPorProjeto = {
  id: "custos-por-projeto",
  titulo: "Custos por Projeto",
  pathModulo: "/custos-por-projeto",
  icone: "Sigma",
  allowedRoles: [
    "admin",
    "rh",
    "financeiro",
    "diretor",
    "administracao",
    "OPERACAO",
    "ASSISTENTEOPERACAO",
    "GESTOR_ESTRATEGICO",
  ],
  descricao:
    "Detalhamento de todos os lançamentos de custo do departamento Operação, agrupados por projeto e, dentro de cada projeto, por categoria de despesa — incluindo o rateio proporcional dos custos gerais de operação entre os projetos.",
  passoAPasso: [
    {
      titulo: "Leia os cards de resumo",
      texto:
        "No topo da tela, os cards mostram o total de Projetos, de Registros (lançamentos), o Valor Rateado (parcela dos custos gerais de operação distribuída entre os projetos) e o Total geral do período filtrado.",
    },
    {
      titulo: "Filtre os lançamentos",
      texto:
        "Use os filtros de Projeto, Categoria, Empresa, Conta, Mês e Ano para restringir a tabela. Todos os filtros (exceto Ano) aceitam múltipla seleção. O botão \"Limpar Filtros\" reseta tudo de uma vez.",
    },
    {
      titulo: "Expanda um projeto",
      texto:
        "Clique na seta ao lado do nome do projeto para abrir o detalhamento por categoria de custo daquele projeto, com o total de cada categoria.",
    },
    {
      titulo: "Veja os lançamentos individuais",
      texto:
        "Dentro de cada categoria expandida, clique para abrir a lista de lançamentos individuais (empresa/fornecedor, conta, data e valor). Lançamentos marcados como \"(RATEIO)\" correspondem à parcela proporcional dos custos gerais de operação alocada àquele projeto.",
    },
    {
      titulo: "Ordene a tabela principal",
      texto:
        "Clique no ícone de ordenação ao lado de \"Projeto\" ou \"Total\" para ordenar a lista de projetos por esses campos.",
    },
  ],
  dicas: [
    "O rateio é calculado proporcionalmente ao custo direto de cada projeto: projetos com custo direto maior recebem uma fatia maior do rateio de operação.",
    "Combine os filtros de Mês e Ano para fechar a análise de um período específico antes de comparar com o orçamento.",
    "Se um projeto aparece com valor de \"Rateio\" mas nenhum \"Custo Direto\", verifique se ele teve movimentação própria no período — pode ser um projeto novo recebendo apenas rateio.",
  ],
  faq: [
    {
      pergunta: "Todos os lançamentos financeiros aparecem aqui?",
      resposta:
        "Não — a tela mostra apenas os lançamentos do departamento Operação. Lançamentos de outros departamentos não entram neste detalhamento.",
    },
    {
      pergunta: "Por que o total exibido é diferente da soma simples dos lançamentos?",
      resposta:
        "O Total considera o custo direto do projeto mais a parcela de rateio recebida, com o sinal invertido para exibição (custos aparecem como valores positivos na tela).",
    },
    {
      pergunta: "Como é calculado o rateio de um projeto?",
      resposta:
        "O total de custos lançados na categoria \"RATEIO DE OPERAÇÕES\" é distribuído entre os demais projetos proporcionalmente ao custo direto (em módulo) de cada um.",
    },
  ],
};

export default custosPorProjeto;
